import * as React from 'react';
import { SearchResultArticle, SearchCategory } from '../../../Model/core';
import { ResultSection, IndexTypeProps } from '.';
import { itemLength } from '../api';

export function ArticleResult(props: IndexTypeProps) {
    const res = props.result as SearchResultArticle[];

    return (
        <ResultSection
            title='Artiklar'
            cls='search-result-articles'
            items={res}
            itemsPerPage={itemLength}
            category={SearchCategory.Product}
            showMore={props.more}>

            <ul>
                {res.map(it =>
                    <li key={it.ArticleNr}>
                        <a href={it.PageLink} className='search-result-article'>
                            {it.ImageUrl && it.ImageUrl != '' && <div className='search-result-article-left'>
                                <img src={`/i/${it.ImageUrl}?mw=100&mh=100&sf=1`} />
                            </div>}
                            <div className='search-result-article-right'>
                                <strong>{it.Title}</strong>
                                <aside>
                                    <span>{it.Desc}</span>
                                </aside>
                            </div>
                        </a>
                    </li>)}
            </ul>
        </ResultSection>
    );
}
